"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    deleteTemplateModal: {
        title: 'Delete "{{title}}"',
        warning: 'This cannot be undone',
        labels: {
            delete: 'Yes, Delete',
            cancel: 'No, Cancel',
            ok: 'Ok',
        },
    },
};
